import React, {Component} from "react";
import {connect} from "react-redux";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import ToggleButton from "../../components/ToggleButton";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {fromJS} from "immutable";
import "./AccountNotifications.css";

class AccountNotifications extends Component {

  constructor(props) {
    super(props);
    this.state = {
      paymentReceiptsSubmitting: false,
      shipmentNotificationsSubmitting: false,
      subscriptionPaymentReceiptsSubmitting: false
    }
  }

  componentDidMount() {
    this.subscribe();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.accountId && (prevProps.accountId !== this.props.accountId)) {
      this.subscribe();
    }
  }

  subscribe() {
    if (this.unsubscribeNotificationChanges) {
      this.unsubscribeNotificationChanges();
    }
    this.unsubscribeNotificationChanges = this.props.subscribeToNotificationChanges(this.props, {});
  }


  render() {
    let {data} = this.props;
    if (data.loading && !data.accountNotifications) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    const notifications = fromJS(data.accountNotifications).get("notifications");

    let paymentReceipts = "off"; // payment_receipts
    let shipmentNotifications = "off"; // shipments
    let subscriptionPaymentReceipts = "off"; // subscription_payment_receipts

    if (notifications.includes("payment_receipts")) {
      paymentReceipts = "on";
    }

    if (notifications.includes("shipments")) {
      shipmentNotifications = "on";
    }

    if (notifications.includes("subscription_payment_receipts")) {
      subscriptionPaymentReceipts = "on";
    }

    return (
      <div className="AccountNotifications">
        <div className="item">
          <ToggleButton state={shipmentNotifications} submitting={this.state.shipmentNotificationsSubmitting} onToggle={this.handleToggleShipmentNotifications.bind(this)} />
          <span className="label">Shipment Notifications</span>
        </div>

        <div className="item">
          <ToggleButton state={subscriptionPaymentReceipts} submitting={this.state.subscriptionPaymentReceiptsSubmitting} onToggle={this.handleToggleSubscriptionPaymentReceipts.bind(this)} />
          <span className="label">Subscription Payment Receipts</span>
        </div>

        <div className="item">
          <ToggleButton state={paymentReceipts} submitting={this.state.paymentReceiptsSubmitting} onToggle={this.handleTogglePaymentReceipts.bind(this)} />
          <span className="label">One-Off Order Receipts</span>
        </div>
      </div>
    )
  }

  enableNotification(notification, updatedState) {
    return this.props.enableNotification({accountId: this.props.accountId, notification: notification})
      .then((response) => {
        if (response.data.enableNotification.errors.length <= 0) {
          this.setState(updatedState);
        }
      })
      .catch((err) => {
        console.warn("Error", err);
        this.setState(updatedState);
      })    
  }

  disableNotification(notification, updatedState) {
    return this.props.disableNotification({accountId: this.props.accountId, notification: notification})
      .then((response) => {
        if (response.data.disableNotification.errors.length <= 0) {
          this.setState(updatedState);
        }
      })
      .catch((err) => {
        console.warn("Error", err);
        this.setState(updatedState);
      })    
  }

  handleToggleShipmentNotifications(value) {
    this.setState({shipmentNotificationsSubmitting: true});
    if (value === "on") {
      this.enableNotification("shipments", {shipmentNotificationsSubmitting: false});
    } else {
      this.disableNotification("shipments", {shipmentNotificationsSubmitting: false});
    }
  }

  handleToggleSubscriptionPaymentReceipts(value) {
    this.setState({subscriptionPaymentReceiptsSubmitting: true});
    if (value === "on") {
      this.enableNotification("subscription_payment_receipts", {subscriptionPaymentReceiptsSubmitting: false});
    } else {
      this.disableNotification("subscription_payment_receipts", {subscriptionPaymentReceiptsSubmitting: false});
    }
  }

  handleTogglePaymentReceipts(value) {
    this.setState({paymentReceiptsSubmitting: true});
    if (value === "on") {
      this.enableNotification("payment_receipts", {paymentReceiptsSubmitting: false});
    } else {
      this.disableNotification("payment_receipts", {paymentReceiptsSubmitting: false});
    }
  }

}

const ENABLE_NOTIFICATION = gql`
  mutation enableNotification($data: NotificationInput!) {
    enableNotification(input: $data) {
      errors { key message }
    }
  }
`;

const DISABLE_NOTIFICATION = gql`
  mutation disableNotification($data: NotificationInput!) {
    disableNotification(input: $data) {
      errors { key message }
    }
  }
`;

const ACCOUNT_NOTIFICATIONS = gql`
  query accountNotifications($accountId:ID!) {
    accountNotifications(accountId:$accountId) {
      accountId
      notifications
    }
  }
`;

const withQueries = compose(
  graphql(ACCOUNT_NOTIFICATIONS, {
    options: (props) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        accountId: props.accountId
      }
    })
  }),
  graphql(ENABLE_NOTIFICATION, {
    props: ({ mutate }) => ({
      enableNotification: (data) => mutate({
        variables: { data: data }
      })
    })
  }),
  graphql(DISABLE_NOTIFICATION, {
    props: ({ mutate }) => ({
      disableNotification: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
); 

const ON_UPDATED_ACCOUNT_NOTIFICATIONS = gql`
  subscription updatedAccountNotifications($accountId: ID!) {
    updatedAccountNotifications(accountId: $accountId) {
      accountId
    }
  }
`

const mapDispatchToProps = dispatch => ({
  subscribeToNotificationChanges: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_UPDATED_ACCOUNT_NOTIFICATIONS,
      variables: {
        accountId: props.accountId
      },
      updateQuery: (prev, { subscriptionData }) => {
        props.data.refetch();
        return prev;
      }
    })
  }
})


export default connect(null, mapDispatchToProps)(withQueries(AccountNotifications));